import { createSelector, MemoizedSelector, createFeatureSelector } from '@ngrx/store';

import { State } from './state';
import { SelectedCard, Card } from '../card.model';

export const cardTypeFeatureState: MemoizedSelector<object, State> =
  createFeatureSelector<State>('cardCheck');

export const getSelectedCard: MemoizedSelector<object, SelectedCard> =
  createSelector(cardTypeFeatureState, (state: State): SelectedCard => state ? state.selectedCard : null);

export const getBinNumber: MemoizedSelector<object, { binNumber: string, binFound: boolean, alternativeBin: boolean }> =
  createSelector(cardTypeFeatureState, (state: State): { binNumber: string, binFound: boolean, alternativeBin: boolean } => ({ binFound: state.binFound, binNumber: state.binNumber, alternativeBin: state.alternativeBin }));

export const getSearchOption: MemoizedSelector<object, string> =
  createSelector(cardTypeFeatureState, (state: State): string => state ? state.cardSearchOption || 'Bin' : 'Bin');

export const getCards: MemoizedSelector<object, Card[]> =
  createSelector(cardTypeFeatureState, (state: State): Card[] => state ? state.cards : null);
